import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteCompanyOperationTypeActions as Actions,
  DeleteCompanyOperationTypeRequestAction as RequestAction,
} from 'store/ducks/companyOperationTypes';

export function* deleteCompanyOperationTypeRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `company-operation-types/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Regra desvinculada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
